import React from "react";
import Field from "../../../../../form/TrafficItemField";
import { classes, Grid } from "../../../../styles/multipleEdit";

const FoldOoh = ({
  editMode,
  areTrafficAgentFieldsDisabled,
  isDebtorActive
}) => {
  return (
    <Grid container justifyContent="flex-start">
      <Grid item className={classes.gridItem}>
        <Field
          component="text"
          id="networkLocations"
          name="networkLocations"
          helperText="Network/Locations"
          label="Network/Locations"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
          variant="standard"
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Field
          component="autocomplete"
          id="digitalFileId"
          name="digitalFileId"
          helperText="Digital File"
          label="Digital File"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
          variant="standard"
          textFieldClassName={classes.field}
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Field
          component="text"
          id="spotLength"
          name="spotLength"
          helperText="Spotlength"
          label="Spotlength"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
          variant="standard"
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Field
          component="date"
          id="deliveryDate"
          name="deliveryDate"
          helperText="Delivery Date"
          label="Delivery Date"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
          hideIcon={!editMode}
          variant="standard"
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Field
          component="text"
          id="technicalSpecifications"
          name="technicalSpecifications"
          helperText="Technical Specifications"
          label="Technical Specifications"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
          variant="standard"
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Field
          component="text"
          id="deliveryAddress"
          name="deliveryAddress"
          helperText="Delivery Address"
          label="Delivery Address"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
          variant="standard"
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Field
          component="text"
          id="vendorReference"
          name="vendorReference"
          helperText="Vendor Reference"
          label="Vendor Reference"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
          variant="standard"
        />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Field
          component="decimal"
          id="numberOfUnitsToDeliver"
          name="numberOfUnitsToDeliver"
          helperText="# of Units to Deliver"
          label="# of Units to Deliver"
          variant="standard"
          disabled={
            !editMode || areTrafficAgentFieldsDisabled || !isDebtorActive
          }
        />
      </Grid>
      <Grid item className={classes.gridItem} xs={12}>
        <Field
          component="text"
          id="trafficItemRemarks"
          name="trafficItemRemarks"
          helperText="Remarks"
          label="Remarks"
          variant="standard"
          rowsMax="6"
          multiline
          isLabelHighlighted
          disabled={!isDebtorActive}
        />
      </Grid>
    </Grid>
  );
};

export default FoldOoh;
